export default __webpack_public_path__ + "static/media/bg_sitab_w.ea0f523e.jpg";